import React from 'react';
import { motion } from 'framer-motion';
import { CheckIcon } from 'lucide-react';
import { pillars, tomos, tomoIncludes } from '../data/tomos';
export function Tomos() {
  return <section aria-label="El sistema completo" className="bg-ink" data-id="element-174" data-mp="1h2udoj7py5gp">
      <div className="mx-auto max-w-6xl px-5 py-12" style={{
      paddingTop: "15px"
    }} data-id="element-175" data-mp="1h573tjnmrm4u">
        <div className="text-center" data-id="element-176" data-mp="1cat79dx8f8yl">
          <p className="text-xs font-bold uppercase tracking-[0.25em] text-naranja-soft" data-id="element-177" data-mp="1r1a3miv0f8om">
            🏆 NEURO-RUNNING PACK™
          </p>
          <h2 className="mt-3 font-display text-3xl font-bold text-white sm:text-4xl" data-id="element-178" data-mp="1m14b70gx1i5h">
            12 Tomos + 5 Bonos
          </h2>
          <p className="mt-2 text-base text-white/60" data-id="element-179" data-mp="1zzuhn6pmku6i">+100 páginas — Todo resuelto.</p>
          <div className="mt-6 flex flex-wrap justify-center gap-2" data-id="element-180" data-mp="1w0v7n7p1e787">
            {pillars.map(p => <span key={p} className="whitespace-nowrap rounded-full border border-plata/25 bg-plata/10 px-3 py-1 text-xs font-bold uppercase tracking-wide text-plata" data-id="element-181" data-mp="5op9bp3lftku">
                {p}
              </span>)}
          </div>
        </div>

        <div className="mt-12 grid gap-4 sm:grid-cols-2 lg:grid-cols-3" data-id="element-182" data-mp="34ovluvm0pvi6">
          {tomos.map((t, i) => <motion.article key={t.n} initial={{
          opacity: 0,
          y: 16
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-40px'
        }} transition={{
          duration: 0.3,
          delay: i % 3 * 0.06,
          ease: [0.23, 1, 0.32, 1]
        }} className="group flex flex-col rounded-2xl border border-azul/15 bg-ink-2 p-5 transition-colors duration-200 ease-out hover:border-azul/60" data-id="element-183" data-mp="39ngjcn9vy12x" data-mpi={i}>
              <div className="flex items-center gap-3" data-id="element-184" data-mp="19q5brxw8b7h">
                <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-azul/15 font-display text-lg font-bold text-azul-soft" data-id="element-185" data-mp="186nhwwl9s3l">
                  {String(t.n).padStart(2, '0')}
                </span>
                <h3 className="text-sm font-bold leading-tight text-white" data-id="element-186" data-mp="27zxnl3f27fg9">
                  <span aria-hidden="true" data-id="element-187" data-mp="282ac5zfboo2a">{t.emoji} </span>
                  {t.title}
                </h3>
              </div>
              <p className="mt-3 text-sm leading-relaxed text-white/60" data-id="element-188" data-mp="1vyo69qa63jy8">{t.desc}</p>
            </motion.article>)}
        </div>

        <div className="mt-10 rounded-2xl border border-plata/20 bg-ink-2 p-6" data-id="element-189" data-mp="29yqo5cih6ddh">
          <p className="text-center font-display text-lg font-bold text-plata" data-id="element-190" data-mp="24yl169n5hf1q">
            ✅ Cada tomo incluye
          </p>
          <ul className="mt-5 grid gap-3 sm:grid-cols-2 lg:grid-cols-3" data-id="element-191" data-mp="2ix2lryhrebff">
            {tomoIncludes.map(item => <li key={item} className="flex items-start gap-2 text-sm text-white/75" data-id="element-192" data-mp="2ewipsy8x9duv">
                <CheckIcon className="mt-0.5 h-4 w-4 shrink-0 text-azul-soft" strokeWidth={3} data-id="element-193" data-mp="2sn3zpxgeedgm" />
                {item}
              </li>)}
          </ul>
        </div>
      </div>
    </section>;
}